import React, { useRef, useState ,useCallback, useEffect} from "react";
import { ActionCircleIcon } from "../../../components/icons/SvgIcons";
import Navbar from "../../../components/navbar/navbarComponent";
import Webcam from "react-webcam";
import { useNavigate } from "react-router-dom";

import jsQR from "jsqr";

function LeerQRComponent() {
  const webcamRef = useRef(null);
  const [qrData, setQrData] = useState(null);
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const captureAndScan = useCallback(() => {
    const canvas = document.createElement("canvas");
    const video = webcamRef.current?.video;

    if (video && video.readyState === 4) {
      const { videoWidth, videoHeight } = video;
      canvas.width = videoWidth;
      canvas.height = videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, videoWidth, videoHeight);
      const imageData = ctx.getImageData(0, 0, videoWidth, videoHeight);

      const qrCode = jsQR(imageData.data, videoWidth, videoHeight);
      if (qrCode) {
        setQrData(qrCode.data);
        navigate(qrCode.data); // Redirige al enlace del QR escaneado
      }
    }
  }, [navigate]);

  useEffect(() => {
    const interval = setInterval(captureAndScan, 1000); // Escanea cada 1s
    return () => clearInterval(interval);
  }, [captureAndScan]);

  return (
    <div className="bg-[#F5FAFF] h-screen">
      <div className="hidden lg:block">
        <Navbar />
      </div>

      <button
        onClick={handleBackClick}
        className="z-50 absolute sm:mt-[2.5rem] mt-[4rem] sm:ml-[5rem] lg:ml-[13rem] ml-[3rem] flex items-center justify-center p-2 rounded-full hover:drop-shadow-[3px_3px_5px_rgba(0,0,0,0.3)] transition ease-in-out duration-200"
      >
        <ActionCircleIcon className="flex flex-start h-12 drop-shadow-[2px_2px_4px_rgba(0,0,0,0.3)]" />
      </button>

      <div className="flex flex-col justify-center items-center ">
        <div className="flex flex-col justify-center ">
          <div className="justify-center mt-[5rem] rounded-lg overflow-hidden">
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              width={500}
              className="sm:w-[500px] w-full "
              videoConstraints={{
                facingMode: { exact: "environment" } // Usa la cámara trasera
              }}
            />
          </div>
          <div className="flex flex-col justify-center items-center     ">
            <div className="text-[#3d4245] text-xl font-bold font-inter absolute bg-[#f5faff] rounded-lg px-[3rem] py-[1rem] shadow-[0px_4px_4px_0px_rgba(29,28,32,0.15)]">
            {qrData ? `Código Detectado: ${qrData}` : "Apunta al QR"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default LeerQRComponent;
